<div class="c-info__block flex flex-col">
    <h5>
        @if (caregiver().isPrimary) {
            Primary
        }
        Caregiver
    </h5>
    <span> {{ caregiverName() }} </span>
    <span>{{ caregiver().relationship }}</span>

    <div class="mt-2 flex flex-row gap-medpace">
        @if (isPatientProfile()) {
            <mds-button
                [id]="'removeCaregiverButton'"
                [variant]="'outline'"
                [color]="'warn'"
                [label]="'Remove'"
                (clickEvent)="caregiverRemovedEvent.emit(caregiver())"
            />
        }
        <mds-button
            [id]="'viewProfileButton'"
            [color]="'primary'"
            [variant]="'outline'"
            [label]="'View profile'"
            (clickEvent)="caregiverModalOpenedEvent.emit(caregiver())"
        />
        @if (!caregiver().isPrimary && isPatientProfile()) {
            <mds-button
                [id]="'makePrimaryButton'"
                [variant]="'outline'"
                [color]="'primary'"
                [label]="'Make primary'"
                (clickEvent)="caregiverSetPrimaryEvent.emit(caregiver())"
            />
        }
    </div>
</div>
